import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ExplorePrograms from './pages/ExplorePrograms';
import Equipments from './pages/Equipments';
import Packages from './pages/Packages';
import Gallery from './pages/Gallery';
import TestimonialsPage from './pages/Testimonials';
import ContactUs from './pages/ContactUs';

function App() {
  return (
    <Router>
      <div className="relative min-h-screen text-white flex flex-col overflow-x-hidden bg-app-pattern bg-hex-overlay selection:bg-red-600 selection:text-white">
        {/* Fixed Ambient Glow Orbs & Subtle Energy Beams */}
        <div className="fixed -top-32 -left-32 w-[35rem] h-[35rem] bg-red-600/20 rounded-full blur-[180px] pointer-events-none -z-0 animate-pulse" style={{ animationDuration: '8s' }} />
        <div className="fixed top-1/3 -right-32 w-[30rem] h-[30rem] bg-red-700/15 rounded-full blur-[170px] pointer-events-none -z-0" />
        <div className="fixed -bottom-32 left-1/4 w-[35rem] h-[35rem] bg-red-800/15 rounded-full blur-[190px] pointer-events-none -z-0" />

        {/* Ambient Top Light Beam Accent */}
        <div className="fixed top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-red-500/40 to-transparent pointer-events-none z-50 blur-[1px]" />

        {/* Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-1 relative z-10 pt-24 md:pt-28">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/explore" element={<ExplorePrograms />} />
            <Route path="/programs" element={<ExplorePrograms />} />
            <Route path="/equipments" element={<Equipments />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
